export default __webpack_public_path__ + "static/media/Posters_placeholder.14f6b5b9.jpg";